import { Button, Modal } from "imagine-ui";
import { Image } from "../..";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  images: Image[];
  onRemove?: (image: Image) => void;
  url: string;
  className?: string;
  readonly?: boolean;
  previewTitle?: string;
}

export const ImageList = (props: Props) => {
  const { t } = useTranslation();
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const currentImage = props.images ? props.images[imageIndex] : undefined;
  const remove = (image: Image) => {
    if (props.onRemove) {
      props.onRemove(image);
    }
  };

  const openImage = (index: number) => {
    setImageIndex(index);
    setShowImageModal(true);
  };

  const closeImage = () => {
    setShowImageModal(false);
  };

  const previousImage = () => {
    if (!props.images) return;
    if (imageIndex > 0) {
      setImageIndex(imageIndex - 1);
    }
  };

  const nextImage = () => {
    if (!props.images) return;
    if (imageIndex < props.images.length - 1) {
      setImageIndex(imageIndex + 1);
    }
  };

  return (
    <div
      className={
        "grid columns-4 columns-2--sm imagelist gap-sm " +
        (props.className ? props.className : "")
      }
    >
      <>
        {props.images.map((image, index) => (
          <div key={index} className={"image-container"}>
            <img
              src={props.url + image.filename}
              className={"fluid" + (props.readonly ? " clickable" : "")}
              onClick={() => openImage(index)}
            />
            <div className=" text-center">
              {t("punchlist:photo") + " " + (image?.number || "0")}
            </div>
            {!props.readonly && (
              <Button
                onClick={() => remove(image)}
                icon="cross"
                size="sm"
                iconSize="sm"
                color="danger"
              />
            )}
          </div>
        ))}
        <Modal
          title={
            props.previewTitle ||
            t("punchlist:photo") + " " + (currentImage?.number || "0")
          }
          visible={showImageModal}
          hideFooter
          size="lg"
          onClose={closeImage}
        >
          {currentImage && props.images && (
            <div className="row">
              <div className="row items-y-center">
                <Button
                  icon="chevron-left"
                  transparent
                  onClick={previousImage}
                  disabled={imageIndex === 0}
                />
              </div>
              <div className="stretch">
                <img
                  src={props.url + currentImage.filename}
                  className="fluid"
                />
              </div>
              <div className="row items-y-center">
                <Button
                  icon="chevron-right"
                  transparent
                  onClick={nextImage}
                  disabled={imageIndex >= props.images.length - 1}
                />
              </div>
            </div>
          )}
        </Modal>
      </>
    </div>
  );
};
